import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthUtilsService } from './auth-utils.service';

export const sendTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authUtilsService = inject(AuthUtilsService);
  const token = authUtilsService.getAccessToken();
  if (token) {
    const newReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(newReq);
  }

  return next(req);
};
